import React from 'react'
import Svg, { SvgProps } from '@/components/svg'
import iconHouseBlack from '../build/icon-house-black'

export const IconHouseBlackComponent: React.FC<Omit<SvgProps, 'src'>> = (
  props
) => {
  return <Svg {...props} src={iconHouseBlack} />
}

export default IconHouseBlackComponent
